import { faGrid2, faList } from '@fortawesome/pro-solid-svg-icons';
import { defineMessages } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from 'atoms/icons';
import { Tab, TabBar } from 'atoms/navigation/TabBar';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useIntlContext } from 'contexts/intl';
import { useIsDesktopAndAbove } from 'hooks/device/useIsDesktopAndAbove';
import useLifecycle, { LIFECYCLE, Lifecycle } from 'hooks/useLifecycle';

import { LineupLayout } from './types';

const messages = defineMessages({
  grid: {
    defaultMessage: 'Use grid layout',
    id: 'LineupsLayoutSwitch.grid',
  },
  list: {
    defaultMessage: 'Use list layout',
    id: 'LineupsLayoutSwitch.list',
  },
});

const SquareTabBar = styled(TabBar)`
  --bar-border-radius: var(--unit);
  --button-border-radius: var(--unit);
`;

const Wrapper = styled.div`
  margin-left: auto;
  margin-right: var(--triple-unit);
`;

export const LineupsLayoutSwitch = () => {
  const { update } = useLifecycle();
  const { formatMessage } = useIntlContext();
  const { currentUser } = useCurrentUserContext();
  const isDesktopAndAbove = useIsDesktopAndAbove();
  const lifecycle = currentUser?.userSettings?.lifecycle as Lifecycle;

  if (!isDesktopAndAbove) return null;
  return (
    <Wrapper>
      <SquareTabBar
        value={lifecycle?.preferedLineupLayout || LineupLayout.LIST}
        onValueChange={async tabValue => {
          await update(LIFECYCLE.preferedLineupLayout, tabValue);
        }}
      >
        <Tab
          value={LineupLayout.LIST}
          aria-label={formatMessage(messages.list)}
        >
          <FontAwesomeIcon icon={faList} />
        </Tab>
        <Tab
          value={LineupLayout.GRID}
          aria-label={formatMessage(messages.grid)}
        >
          <FontAwesomeIcon icon={faGrid2} />
        </Tab>
      </SquareTabBar>
    </Wrapper>
  );
};
